/**
 * Defines the signalr events in the system.
 */
export enum SignalrEvents {

    MedicalCheckupListChanged = "MedicalCheckupListChanged",

    // Test event
    SomeEventReceived = "SomeEventReceived",
}
